import React from 'react';
import { Route } from 'react-router-dom';
import * as ROUTES from '../constants/routes';

import FileNew from '../pages/files/new';
import FileEdit from '../pages/files/edit';

export const fileRoutes = () => (
  <>
    <Route path={ROUTES.FILES_NEW} element={<FileNew />} />
    <Route path={ROUTES.FILES_EDIT} element={<FileEdit />} />
  </>
);
